import {
  updateNodeSelectionNodeData,
  updateNodeSelectionNodeEditedState,
  updateNodeSelectionState,
} from "@src/reducers/your-reducer";
import { buildNodeSelectionNodeData } from "../../../use-cases/build-node-selection-node-data";

export const writeNodeDetailsOurNode = (dispatch, child, list, type) => {
  dispatch(updateNodeSelectionNodeEditedState(false));
  dispatch(
    updateNodeSelectionNodeData(buildNodeSelectionNodeData(child, list)),
  );
  if (child.node_type !== "FOLDER") {
    if (type === "initial") {
      dispatch(updateNodeSelectionState("show"));
    } else {
      dispatch(updateNodeSelectionState("edit"));
    }
  } else {
    dispatch(updateNodeSelectionState("none"));
  }
};

export const writeEmptyNodeDetails = (dispatch, child) => {
  dispatch(updateNodeSelectionNodeEditedState(false));
  dispatch(updateNodeSelectionNodeData(child));
  dispatch(updateNodeSelectionState("none"));
};
